

import Vue from 'vue'
import FastClick from 'fastclick'
import api from './api'
import App from './App'
import router from './router'
import authentication from './utill/authentication'
import utill from './utill'
import store, {types as storeTypes} from './store'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'

import './filters'
import './assets/styles/common.scss'
import VueScroller from 'vue-scroller'
import "@/assets/font/font.css";
import md5 from 'js-md5';
import moment from 'moment'
import sign from "./utill/signUtils";

Vue.use(VueScroller)

Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)
Vue.use(DatetimePlugin)
Vue.mixin(authentication)
Vue.mixin(utill)
Vue.prototype.$http = api.$http
Vue.prototype.$md5 = md5;
Vue.prototype.$moment = moment;
Vue.prototype.$sign = sign;

router.beforeEach(async function (to, from, next) {

var title = '椰泰二维码防伪系统';
document.title = to.meta.title || title;
store.commit(storeTypes.UPDATE_MASK, true)
let user = store.state.user;
let wxUser = store.state.wxUser;
console.log('to，user, wxUser', to, user, wxUser);
if(to.name === "serverMsg"){
if(to.query && to.query.customerId){

localStorage.setItem('_customerInfo', JSON.stringify(to.query));

}
}


if (to.name !== 'wx-login') {
if(to.name == 'waiterQRcode'
||to.name == 'error'
||to.name == 'waitersList'
||to.name == 'waitersDetail'){
console.log('不用授权')
next();
}else if (!wxUser) {
let _wxUser = await api.wx.user(to.path);
console.log("wxUser", _wxUser);
if (_wxUser) {
if(to.name !=='psw-login' && to.meta && to.meta.login) {
let platFormUser = await api.pt.homeInit();
if (!platFormUser) {
next({
name: 'psw-login',
query: {from: to.path}
})
}
}
} else {
next({
name: 'wx-login',
query: {from: '/#' + to.path, data: to.query}
})
}
}
else {
if((!user || !user.account) && to.meta && to.meta.login) {

let userData = await api.pt.homeInit();
if (!userData) {
next({
name: 'psw-login',
query: {from: to.path}
})
}
}
}
}
next();
})

router.afterEach(function (to) {
console.log('after',to);
store.commit(storeTypes.UPDATE_MASK, false);
})
FastClick.attach(document.body)

Vue.config.productionTip = false

new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js